/**
 * Return price with commas
 *
 * @param {string} price
 * @returns {string} final price converted
 */
function convertPrice(price) {
  let priceConverted = '';

  priceConverted = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return `$${priceConverted}`;
}

export default convertPrice;
